import { apiRequest } from "./apiClient";

function pageQuery({ page = 0, size = 20 } = {}) {
  const params = new URLSearchParams();
  params.set("page", Math.max(0, Number(page) || 0));
  params.set("size", Math.min(100, Math.max(1, Number(size) || 20)));
  return params.toString();
}

export function listIpAccessRules(options) {
  return apiRequest(`/api/ip-access-rules?${pageQuery(options)}`);
}

export function createIpAccessRule(values) {
  return apiRequest("/api/ip-access-rules", { method: "POST", body: JSON.stringify(values) });
}

export function updateIpAccessRule(id, values) {
  return apiRequest(`/api/ip-access-rules/${id}`, { method: "PUT", body: JSON.stringify(values) });
}
